import React from "react";
import { Form, Button, Select } from "antd";

import { getTranslation } from "../../utils/helper";
import AddressInput from "../Inputs/AddressInput";
import { isEmpty, uniq } from "lodash";
import { useDispatch } from "react-redux";

import { doUpdateAndOptimizeRoutePlan } from "../../modules/routePlan/stores/thunk";
import markerIcons from "../Markers/markerIcons";

import "./index.scss";

const StopsSelected = ({ routePlan, stops, routes, setIsBulkUpdateStopsSelected, setting }) => {
  const dispatch = useDispatch();
  const drivers = routes.map(r => r.driver);
  const [form] = Form.useForm();

  const handleCancel = () => {
    setIsBulkUpdateStopsSelected(false);
  };

  const handleForceReassign = () => {
    const values = form.getFieldsValue();
    const params = setParams(values);
    if (!isEmpty(params)) {
      params.orderIds = uniq(stops.map(s => s.orderId));
      dispatch(
        doUpdateAndOptimizeRoutePlan({
          id: routePlan._id,
          isReassign: true,
          forceAll: true,
          ...params,
        }),
      );
    }
    setIsBulkUpdateStopsSelected(false);
  };

  const setParams = values => {
    const params = {};
    const pickupAddress = values.pickupAddress;
    if (pickupAddress?.address && pickupAddress?.latLng?.lat && pickupAddress?.latLng?.lng) {
      params.pickupAddress = pickupAddress?.address;
      params.pickupLat = pickupAddress?.latLng?.lat;
      params.pickupLng = pickupAddress?.latLng?.lng;
    }
    const deliveryAddress = values.deliveryAddress;
    if (deliveryAddress?.address && deliveryAddress?.latLng?.lat && deliveryAddress?.latLng?.lng) {
      params.deliveryAddress = deliveryAddress?.address;
      params.deliveryLat = deliveryAddress?.latLng?.lat;
      params.deliveryLng = deliveryAddress?.latLng?.lng;
    }
    if (values.driverId) {
      params.driverId = values.driverId;
    }
    return params;
  };

  const handleOnFinish = values => {
    const params = setParams(values);
    if (!isEmpty(params)) {
      params.orderIds = uniq(stops.map(s => s.orderId));
      dispatch(
        doUpdateAndOptimizeRoutePlan({
          id: routePlan._id,
          isReassign: true,
          ...params,
        }),
      );
    }
    setIsBulkUpdateStopsSelected(false);
  };

  return (
    <div className="StopsSelected">
      <div className="StopsSelectedForm">
        <div className="Title">Update {stops.length} stops</div>
        <div className="OrderForm">
          <Form
            form={form}
            scrollToFirstError
            layout="vertical"
            hideRequiredMark
            colon={false}
            onFinish={handleOnFinish}
            initialValues={{
              pickupAddress: {},
              deliveryAddress: {},
            }}>
            <div className="FormContent">
              <Form.Item label={getTranslation(setting, "Route Plans", "Reassign to another driver")} name="driverId">
                <Select
                  size="large"
                  showSearch
                  optionFilterProp="children"
                  placeholder={getTranslation(setting, "Orders", "Drivers")}>
                  {drivers.map(d => (
                    <Select.Option key={d._id} value={d._id}>
                      <img style={{ paddingRight: "4px" }} src={markerIcons["driver"][d.color]} />
                      {d.name}
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item>
              <Form.Item
                label={getTranslation(setting, "Orders", "Pickup Address")}
                name="pickupAddress"
                rules={[
                  {
                    validator: (_, value) => {
                      console.log(value);
                      if ((value?.address && value?.latLng?.lat && value?.latLng?.lng) || isEmpty(value?.address)) {
                        return Promise.resolve();
                      }

                      if (isEmpty(value?.address)) {
                        return Promise.resolve();
                      }

                      return Promise.reject(new Error("Invalid"));
                    },
                  },
                ]}>
                <AddressInput
                  size="large"
                  placeholder={getTranslation(setting, "Orders", "Pickup Address")}
                  onSelect={value => form.setFieldsValue({ pickupAddress: value })}
                />
              </Form.Item>
              <Form.Item
                label={getTranslation(setting, "Orders", "Delivery Address")}
                name="deliveryAddress"
                rules={[
                  {
                    validator: (_, value) => {
                      if ((value?.address && value?.latLng?.lat && value?.latLng?.lng) || isEmpty(value?.address)) {
                        return Promise.resolve();
                      }

                      return Promise.reject(new Error("Invalid"));
                    },
                  },
                ]}>
                <AddressInput
                  size="large"
                  placeholder={getTranslation(setting, "Orders", "Delivery Address")}
                  onSelect={value => form.setFieldsValue({ deliveryAddress: value })}
                />
              </Form.Item>
            </div>
            <div className="FormFooter">
              <div className="Left"></div>
              <div className="Right buttons">
                <Button key="cancel" onClick={handleCancel}>
                  {getTranslation(setting, "Common", "Cancel")}
                </Button>
                <Button htmlType="submit" type="primary" className="btn-blue">
                  {getTranslation(setting, "Common", "Reassign")}
                </Button>
                <Button onClick={handleForceReassign} type="primary">
                  {getTranslation(setting, "Common", "Force Reassign")}
                </Button>
              </div>
            </div>
          </Form>
        </div>
      </div>
    </div>
  );
};

export default StopsSelected;
